import React from 'react';
import { Popover, MenuList, MenuItem } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export interface GroupActionsMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
}

const GroupActionsMenu: React.FC<GroupActionsMenuProps> = ({
  anchorEl,
  open,
  onClose,
  onDelete,
}) => (
  <Popover
    open={open}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    data-testid="actions-popover"
  >
    <MenuList>
      <MenuItem
        onClick={onDelete}
        sx={{ color: 'error.main' }}
        data-testid="delete-menu-item"
      >
        <DeleteIcon fontSize="small" sx={{ mr: 1 }} />
        Delete
      </MenuItem>
    </MenuList>
  </Popover>
);

export default GroupActionsMenu;
